module.exports = __webpack_public_path__ + "static/media/howToPlay4.824b3665.png";